/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramGeoControllerFindAnyByIdQueryResponse,
  TelegramGeoControllerFindAnyByIdPathParams,
} from '../../types/TelegramGeoControllerFindAnyById.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoFindAnyById } from '../../methods/telegramGeoFindAnyById.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoFindAnyByIdQueryKey = (id: TelegramGeoControllerFindAnyByIdPathParams['id']) =>
  [{ url: '/api/telegram/geo/:id', params: { id: id } }] as const;

export type TelegramGeoFindAnyByIdQueryKey = ReturnType<typeof telegramGeoFindAnyByIdQueryKey>;

export function telegramGeoFindAnyByIdQueryOptions(
  id: TelegramGeoControllerFindAnyByIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoFindAnyByIdQueryKey(id);
  return queryOptions<
    TelegramGeoControllerFindAnyByIdQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerFindAnyByIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoFindAnyById(id, config);
    },
  });
}

/**
 * {@link /api/telegram/geo/:id}
 */
export function useTelegramGeoFindAnyById<
  TData = TelegramGeoControllerFindAnyByIdQueryResponse,
  TQueryData = TelegramGeoControllerFindAnyByIdQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoFindAnyByIdQueryKey,
>(
  id: TelegramGeoControllerFindAnyByIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerFindAnyByIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoFindAnyByIdQueryKey(id);

  const query = useQuery(
    {
      ...telegramGeoFindAnyByIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
